import { useState, useEffect } from "react";
import { api } from "../api";

const TIPI_PROMO = {
  sconto_canone:      "Sconto % canone",
  sconto_attivazione: "Sconto % attivazione",
  attivazione_gratuita:"Attivazione gratuita",
  prezzo_fisso:       "Prezzo fisso",
  mesi_gratuiti:      "Mesi gratuiti",
  bundle:             "Bundle",
  sconto_totale:      "Sconto % totale",
};

const TIPO_COLOR = {
  sconto_canone:       { bg: "#eff6ff", color: "#1d4ed8" },
  sconto_attivazione:  { bg: "#f5f3ff", color: "#7c3aed" },
  attivazione_gratuita:{ bg: "#f0fdf4", color: "#15803d" },
  prezzo_fisso:        { bg: "#fef3c7", color: "#92400e" },
  mesi_gratuiti:       { bg: "#f0fdf4", color: "#15803d" },
  bundle:              { bg: "#fef2f2", color: "#dc2626" },
  sconto_totale:       { bg: "#eff6ff", color: "#1d4ed8" },
};

const TIPI_CLIENTE = ["DOM", "AZ", "PA"];
const fmt = (n) => n ? Number(n).toFixed(2).replace(".", ",") + " €" : "";

const VUOTO = {
  nome: "", descrizione: "", tipo: "sconto_canone", valore: "",
  tipi_cliente: [], servizi_ids: [], durata_contratto_min: 0,
  data_inizio: "", data_fine: "", richiede_approvazione: false, attiva: true,
};

function ModalePromozione({ promo, onSalva, onClose }) {
  const [form, setForm] = useState(promo || VUOTO);
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    setSaving(true);
    try {
      if (promo) await api.modificaPromozione(promo.id, form);
      else await api.creaPromozione(form);
      onSalva();
    } catch (e) { alert(e.message); }
    setSaving(false);
  };

  const toggleTipoCliente = (tc) => {
    const list = form.tipi_cliente || [];
    setForm({ ...form, tipi_cliente: list.includes(tc) ? list.filter(x => x !== tc) : [...list, tc] });
  };

  const mostraValore = !["attivazione_gratuita"].includes(form.tipo);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <h2 className="card-title">{promo ? "Modifica promozione" : "Nuova promozione"}</h2>

        <div className="form-grid">
          <div className="form-group span-2">
            <label className="form-label">Nome promozione *</label>
            <input className="form-input" value={form.nome}
              onChange={e => setForm({...form, nome: e.target.value})}
              placeholder="Es. Promo Estate 2026" />
          </div>

          <div className="form-group span-2">
            <label className="form-label">Descrizione (mostrata nel PDF)</label>
            <textarea className="form-input" rows={2} value={form.descrizione || ""}
              onChange={e => setForm({...form, descrizione: e.target.value})}
              placeholder="Es. Attivazione gratuita per contratti ≥24 mesi" />
          </div>

          <div className="form-group">
            <label className="form-label">Tipo promozione *</label>
            <select className="form-input" value={form.tipo}
              onChange={e => setForm({...form, tipo: e.target.value})}>
              {Object.entries(TIPI_PROMO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>

          {mostraValore && (
            <div className="form-group">
              <label className="form-label">
                {["sconto_canone","sconto_attivazione","bundle","sconto_totale"].includes(form.tipo) ? "Sconto %" : form.tipo === "mesi_gratuiti" ? "N° mesi gratuiti" : "Prezzo €"}
              </label>
              <input className="form-input" type="number" step="0.01" value={form.valore || ""}
                onChange={e => setForm({...form, valore: parseFloat(e.target.value) || 0})} />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Data inizio</label>
            <input className="form-input" type="date" value={form.data_inizio || ""}
              onChange={e => setForm({...form, data_inizio: e.target.value})} />
          </div>

          <div className="form-group">
            <label className="form-label">Data fine</label>
            <input className="form-input" type="date" value={form.data_fine || ""}
              onChange={e => setForm({...form, data_fine: e.target.value})} />
          </div>

          <div className="form-group">
            <label className="form-label">Durata contratto minima (mesi)</label>
            <input className="form-input" type="number" min="0" value={form.durata_contratto_min || 0}
              onChange={e => setForm({...form, durata_contratto_min: parseInt(e.target.value) || 0})} />
            <small style={{ color: "#94a3b8", fontSize: 11 }}>0 = nessun vincolo</small>
          </div>

          <div className="form-group span-2">
            <label className="form-label">Tipi cliente (vuoto = tutti)</label>
            <div style={{ display: "flex", gap: 8 }}>
              {TIPI_CLIENTE.map(tc => (
                <button key={tc} className={`chip ${(form.tipi_cliente || []).includes(tc) ? "active" : ""}`}
                  onClick={() => toggleTipoCliente(tc)}>{tc}</button>
              ))}
            </div>
          </div>

          <div className="form-group span-2" style={{ display: "flex", gap: 20 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
              <input type="checkbox" checked={!!form.richiede_approvazione}
                onChange={e => setForm({...form, richiede_approvazione: e.target.checked})} />
              Richiede approvazione dirigente
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
              <input type="checkbox" checked={!!form.attiva}
                onChange={e => setForm({...form, attiva: e.target.checked})} />
              Promozione attiva
            </label>
          </div>
        </div>

        <div className="step-actions">
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" onClick={salva} disabled={saving || !form.nome || !form.tipo}>
            {saving ? "Salvataggio..." : "Salva promozione"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Promozioni() {
  const [lista, setLista]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modale, setModale] = useState(null);
  const [filtroAttive, setFiltroAttive] = useState(false);

  const carica = async () => {
    setLoading(true);
    try {
      const params = filtroAttive ? { attiva: "1" } : {};
      setLista(await api.getPromozioni(params));
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { carica(); }, [filtroAttive]);

  const elimina = async (id) => {
    if (!window.confirm("Eliminare questa promozione?")) return;
    try { await api.eliminaPromozione(id); carica(); }
    catch (e) { alert(e.message); }
  };

  const oggi = new Date().toISOString().slice(0, 10);
  const isAttiva = (p) => p.attiva && (!p.data_inizio || p.data_inizio <= oggi) && (!p.data_fine || p.data_fine >= oggi);

  return (
    <div className="page">
      <div className="page-header">
        <h1>Promozioni</h1>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
            <input type="checkbox" checked={filtroAttive} onChange={e => setFiltroAttive(e.target.checked)} />
            Solo attive
          </label>
          <button className="btn btn-primary" onClick={() => setModale({ isNuovo: true })}>+ Nuova promo</button>
        </div>
      </div>

      {loading && <div className="loading">Caricamento...</div>}

      {!loading && lista.length === 0 && (
        <div className="empty-state">
          <div style={{ fontSize: 48 }}>🎁</div>
          <div>Nessuna promozione</div>
          <button className="btn btn-primary" onClick={() => setModale({ isNuovo: true })}>Crea la prima</button>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {lista.map(p => {
          const attiva = isAttiva(p);
          const tc = (() => { try { return p.tipi_cliente ? JSON.parse(p.tipi_cliente) : []; } catch { return []; } })(); 
          const colore = TIPO_COLOR[p.tipo] || { bg: "#f1f5f9", color: "#64748b" };
          return (
            <div key={p.id} className="card" style={{ padding: "16px 20px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 14, fontWeight: 700 }}>{p.nome}</span>
                    <span className="stato-badge" style={{ background: colore.bg, color: colore.color }}>
                      {TIPI_PROMO[p.tipo]}
                    </span>
                    <span className="stato-badge" style={{ background: attiva ? "#f0fdf4" : "#fef2f2", color: attiva ? "#15803d" : "#dc2626" }}>
                      {attiva ? "✅ Attiva" : "⬜ Inattiva"}
                    </span>
                    {p.richiede_approvazione && (
                      <span className="stato-badge" style={{ background: "#fef3c7", color: "#92400e" }}>⚠️ Richiede approv.</span>
                    )}
                  </div>
                  {p.descrizione && <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{p.descrizione}</div>}
                  <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6, display: "flex", gap: 12, flexWrap: "wrap" }}>
                    {p.valore > 0 && <span>Valore: <strong>{p.tipo === "prezzo_fisso" ? fmt(p.valore) : p.tipo === "mesi_gratuiti" ? `${p.valore} mesi` : `${p.valore}%`}</strong></span>}
                    {tc.length > 0 && <span>Clienti: <strong>{tc.join(", ")}</strong></span>}
                    {p.durata_contratto_min > 0 && <span>Min durata: <strong>{p.durata_contratto_min} mesi</strong></span>}
                    {p.data_inizio && <span>Dal: <strong>{new Date(p.data_inizio).toLocaleDateString("it-IT")}</strong></span>}
                    {p.data_fine && <span>Al: <strong>{new Date(p.data_fine).toLocaleDateString("it-IT")}</strong></span>}
                    {p.creato_da_nome && <span>Creata da: <strong>{p.creato_da_nome}</strong></span>}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn-icon" onClick={() => setModale({ isNuovo: false, promo: p })}>✏️</button>
                  <button className="btn-icon" onClick={() => elimina(p.id)}>🗑</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {modale && (
        <ModalePromozione
          promo={modale.isNuovo ? null : modale.promo}
          onSalva={() => { setModale(null); carica(); }}
          onClose={() => setModale(null)} />
      )}
    </div>
  );
}
